// extracted by mini-css-extract-plugin
export var bottom = "style-module--bottom--20fed";
export var btnPause = "style-module--btn-pause--66365";
export var btnPlay = "style-module--btn-play--1b84c";
export var btnSound = "style-module--btn-sound--eb470";
export var btnSoundWrap = "style-module--btn-sound-wrap--497a3";
export var c = "style-module--c--e22ce";
export var count = "style-module--count--99a73";
export var direction = "style-module--direction--550c5";
export var error = "style-module--error--e6680";
export var fadeIn = "style-module--fade-in--31bda";
export var fadeOut = "style-module--fade-out--cd101";
export var info = "style-module--info--99439";
export var left = "style-module--left--ef79b";
export var mountedAnimation = "style-module--mountedAnimation--78aaf";
export var right = "style-module--right--28409";
export var sb = "style-module--sb--a9608";
export var success = "style-module--success--d6875";
export var top = "style-module--top--d6b19";
export var unmountedAnimation = "style-module--unmountedAnimation--8ca68";